import React from 'react';

import styled from '@emotion/styled';

interface ISummaryCard {
  stats: number;
  label: string;
  imgName: string;
}

const SummaryCard: React.FC<ISummaryCard> = ({ stats, label, imgName }) => {
  return (
    <Container>
      <Img src={`/static/img/${imgName}`} alt={`${label}`} />
      <TextArea>
        <Stats>{stats}</Stats>
        <Label>{label}</Label>
      </TextArea>
    </Container>
  );
};

export default SummaryCard;

const Container = styled.div`
  display: flex;
  gap: 1rem;
  /* border: 2px solid red; */
  align-items: center;
`;

const TextArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0rem;
`;

const Stats = styled.div`
  font-weight: 600;
  font-size: 1.5rem;
  color: ${({ theme }) => theme.palette.secondaryTextColor};
`;

const Label = styled.div`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.palette.tertiaryText};
`;

const Img = styled.img`
  /* outline: 1px solid orange; */
  object-fit: fit;
  width: 3rem;
  height: 3rem;
`;
